// Shared site config. Update these in one place.
export const CONTACT_EMAIL = "contact@domichron.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/felixmbiko/";
export const DOMESCRIBE_URL = "#"; // TODO confirm DomeScribe URL
export const KREET_URL = "#"; // TODO confirm Kreet AI URL
export const DOMESCRIBE_STATUS = "Live"; // TODO confirm: "Live" | "In beta"
export const KREET_STATUS = "Launching June 2026";
